import React, { useState } from "react";
import Header from "./header";
import Sidebar from "./sidebar";
import { IoClose } from "react-icons/io5";
import { useUser } from "../config/userProvider";
import MobileFooter from "./mobileFooter";
import { href, Link, NavLink, useLocation } from "react-router-dom";
import AdminHeader from "./adminHeader";
import {
  FaFile,
  FaList,
  FaQuestion,
  FaShoppingCart,
  FaSignOutAlt,
  FaUsers,
} from "react-icons/fa";
import {
  FaTachometerAlt,
  FaThLarge,
  FaChartBar,
  FaTable,
  FaBell,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import PortalSelector from "./portalSelector";
import { FaTicket } from "react-icons/fa6";
import { CiDeliveryTruck } from "react-icons/ci";
import { BsDashCircleFill } from "react-icons/bs";
import { ActivityIcon, LayoutDashboardIcon, List, ShipIcon, SwatchBook } from "lucide-react";

// HRMS Layout
const HrmsLayout = ({ children }) => (
  <div className="w-full h-screen bg-green-100">
    <div className="p-4 bg-green-600 text-white">HRMS Header</div>
    <div className="p-4">{children}</div>
  </div>
);

const Layout = ({ children }) => {
  const {
    openProfile,
    setCloseProfile,
    isMenuOpen,
    setIsMenuOpen,
    showSearch,
    setShowSearch,
  } = useUser();

  const location = useLocation();
  const path = location.pathname;

  // Conditional Layout Logic
  if (path.startsWith("/sales/")) {
    return <SalesLayout>{children}</SalesLayout>;
  }

  if (path.startsWith("/payroll/")) {
    return <PayrollLayout>{children}</PayrollLayout>;
  }

  // Default Layout

  if (location.pathname.startsWith("/nolayout")) {
    return <>{children}</>; // 👈 just main content
  }
  return (
    <div
      className="layout h-screen w-full overflow-hidden bg-zinc-50"
      onClick={() => (openProfile === true ? setCloseProfile(false) : null)}
    >
      <div className="flex h-full md:p-1">
        {/* Sidebar */}
        <div
          className={`sm:relative transition-all duration-500 ease-in-out sm:translate-x-0 z-20 pb-8 overflow-hidden ${
            isMenuOpen
              ? "absolute flex w-3/4 z-40 opacity-100 translate-x-0"
              : "absolute flex w-3/4 sm:w-auto lg:w-[15%] -translate-x-full opacity-0 sm:opacity-100"
          } md:flex flex-col md:relative gap-4 items-center h-full px-3 pt-2 shadow-sm bg-[#39160d]`}
        >
          <div className="w-full flex justify-between items-center">
            <div className="flex justify-center w-full">
              <img
                className="w-auto h-10 lg:h-12 max-h-12 max-w-33 sm:block md:hidden lg:block brightness-[1000000]"
                src="/suwasthi-logo-white.png"
                alt="logo"
              />
            </div>
            <div
              className="text-2xl text-[#d8c9ae] block md:hidden cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              <IoClose />
            </div>
          </div>
          <Sidebar />
        </div>

        {/* Main Section */}
        <div className="w-full lg:w-[85%] flex flex-col overflow-hidden h-full border border-[#d8c9ae]">
          {isMenuOpen && (
            <div
              className="block lg:hidden w-full h-full fixed backdrop-blur-[0.2rem] z-30"
              onClick={() => setIsMenuOpen(false)}
            ></div>
          )}
          <AdminHeader className="h-[5vh]" />
          <div
            className="h-[95vh] overflow-hidden"
            onClick={() => setCloseProfile(false)}
          >
            {children}
          </div>
          <MobileFooter />
        </div>
      </div>
    </div>
  );
};

export default Layout;
export const Container = ({ children, className, overflow, ...props }) => {
  return (
    <div
      className={`bg-white/100 relative rounded-2xl p-2  h-full ${className} ${
        overflow ? overflow : "overflow-hidden"
      } `}
      {...props}
    >
      {children}
    </div>
  );
};
function NavItem({ icon, label, badge, href = "#", active }) {
  return (
    <NavLink to={href}>
      <div
        className={`flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer ${
          active ? "bg-blue-100 text-blue-700" : "hover:bg-gray-100"
        }`}
      >
        <div className="flex items-center gap-2">
          {icon}
          <span>{label}</span>
        </div>
        {badge && (
          <span className="bg-yellow-400 text-xs px-2 py-0.5 rounded-full text-white">
            {badge}
          </span>
        )}
      </div>
    </NavLink>
  );
}

export const SalesLayout = ({
  children,
  moduleColor = "bg-blue-600",
  logo = "/suwasthi-logo-white.png",
}) => {
  const { openProfile, setCloseProfile, isMenuOpen, setIsMenuOpen } = useUser();

  return (
    <div
      className="layout h-screen w-full overflow-hidden bg-zinc-50"
      onClick={() => (openProfile ? setCloseProfile(false) : null)}
    >
      <div className="flex h-full md:p-1">
        {/* Sidebar */}
        <div
          className={`sm:relative transition-all duration-500 ease-in-out sm:translate-x-0 z-20 pb-8 overflow-hidden ${
            isMenuOpen
              ? "absolute flex w-3/4 z-40 opacity-100 translate-x-0"
              : "absolute flex w-3/4 sm:w-auto lg:w-[15%] -translate-x-full opacity-0 sm:opacity-100"
          } md:flex flex-col md:relative gap-4 items-center h-full px-3 md:px-1 md:py-0 pt-2 shadow-sm bg-white`}
        >
          <div className="w-full flex justify-between items-center bg-blue-600 py-1">
            <div className="flex justify-center w-full ">
              <img
                src="/suwasthi-logo-white.png"
                className=" h-16 p-1"
                alt=""
              />
            </div>
            <div
              className="text-2xl text-[#d8c9ae] block md:hidden cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              <IoClose />
            </div>
          </div>
          <div className="w-full bg-white flex flex-col justify-between h-full">
            <div>
              <nav className="flex flex-col gap-2 p-4">
                <NavItem
                  icon={<LayoutDashboardIcon />}
                  label="Dashboard"
                  href="/sales/dashboard"
                  active={href === "/sales/dashboard" ? true : false}
                />
                {/* <NavItem
                  icon={<FaShoppingCart />}
                  label="Orders"
                  href="/sales/orders"
                  // badge="3"
                  active={href === "/sales/orders" ? true : false}
                /> */}

                <NavItem
                  icon={<ShipIcon />}
                  label="Shipments"
                  href="/sales/shipments"
                  // badge=""
                  active={href === "/sales/shipments" ? true : false}
                />

                <NavItem
                  icon={<ActivityIcon />}
                  label="Ozonetel"
                  href="/sales/ozonetel"
                  // badge=""
                  active={href === "/sales/ozonetel" ? true : false}
                />
                <NavItem
                  icon={<List />}
                  label="Leads"
                  href="/sales/leads"
                  // badge=""
                  active={href === "/sales/leads" ? true : false}
                />
                {/* <NavItem
                  icon={<FaUsers />}
                  label="Customers"
                  href="/sales/customers"
                /> */}
              </nav>
            </div>
            <div className="border-t">
              {/* <div className="flex flex-col gap-3 p-4">
                <button className="flex items-center gap-2 text-red-500">
                  <FaSignOutAlt /> Logout
                </button>
              </div> */}
            </div>
          </div>
        </div>

        {/* Main Section */}
        <div className="w-full lg:w-[85%] flex flex-col overflow-hidden h-full border border-[#d8c9ae]">
          {isMenuOpen && (
            <div
              className="block lg:hidden w-full h-full fixed backdrop-blur-[0.2rem] z-30"
              onClick={() => setIsMenuOpen(false)}
            ></div>
          )}
          <AdminHeader className="h-[5vh]" />
          <div
            className="h-[95vh] overflow-hidden"
            onClick={() => setCloseProfile(false)}
          >
            {children}
          </div>
          <MobileFooter />
        </div>
      </div>
    </div>
  );
};

export const PayrollLayout = ({
  children,
  moduleColor = "bg-blue-600",
  logo = "/suwasthi-logo-white.png",
}) => {
  const { openProfile, setCloseProfile, isMenuOpen, setIsMenuOpen } = useUser();

  return (
    <div
      className="layout h-screen w-full overflow-hidden bg-zinc-50"
      onClick={() => (openProfile ? setCloseProfile(false) : null)}
    >
      <div className="flex h-full md:p-1">
        <div
          className={` bg-[#4B49AC] sm:relative transition-all duration-500 ease-in-out sm:translate-x-0 z-20 pb-8 overflow-hidden ${
            isMenuOpen
              ? "absolute flex w-3/4 z-40 opacity-100 translate-x-0"
              : "absolute flex w-3/4 sm:w-auto lg:w-[15%] -translate-x-full opacity-0 sm:opacity-100"
          } md:flex flex-col md:relative gap-4 items-center h-full px-3 md:px-1 md:py-0 pt-2 shadow-sm bg--100  bg-[#4B49AC]`}
        >
          <div className="w-full flex justify-between items-center bg-[#4B49AC] text-white  py-1">
            <div className="flex justify-center w-full ">
              <img
                src="/suwasthi-logo-white.png"
                className=" h-16 p-1"
                alt=""
              />
            </div>
            <div
              className="text-2xl text-[#d8c9ae] block md:hidden cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              <IoClose />
            </div>
          </div>
          <div className="w-full bg-[#4B49AC] text-white flex flex-col justify-between h-full">
            <div>
              <nav className="flex flex-col gap-2 p-4 text-sm mt-6">
                {[
                  {
                    name: "Dashboard",
                    icon: <FaTachometerAlt />,
                    to: "dashboard",
                  },
                  { name: "Attendance", icon: <FaThLarge />, to: "attendance" },
                  { name: "Tickets", icon: <FaTicket />, to: "tickets" },
                  {
                    name: "Notifications",
                    icon: <FaBell />,
                    to: "notifications",
                  },
                  {
                    name: "Upload Attendance",
                    icon: <FaFile />,
                    to: "upload-attendance",
                  },
                  {
                    name: "Employee Management",
                    icon: <FaFile />,
                    to: "employee-management",
                  },
                  {
                    name: "Manage Attendance",
                    icon: <FaFile />,
                    to: "manage-attendance",
                  },
                  {
                    name: "Employees",
                    icon: <FaUsers />,
                    to: "employees",
                  },
                  {
                    name: "Conducts",
                    icon: <FaFile />,
                    to: "conducts",
                  },
                ].map((item, i) => (
                  <NavLink
                    key={i}
                    to={`/payroll/${item.to}`}
                    className={({ isActive }) =>
                      `flex items-center gap-2 text-left px-3 py-2 rounded-lg hover:bg-[#7978e9] ${
                        isActive
                          ? "bg-white text-[#4B49AC] font-semibold"
                          : "text-white"
                      }`
                    }
                  >
                    {item.icon}
                    {item.name}
                  </NavLink>
                ))}
              </nav>
            </div>
            <div className="border-t">
              <div className="flex flex-col gap-3 p-4">
                <Link
                  to="/hrms/dashboard"
                  className="flex items-center gap-2 text-white-500"
                >
                  <SwatchBook /> HRMS
                </Link>
                <Link
                  to="/sales/dashboard"
                  className="flex items-center gap-2 text-white-500"
                >
                  <SwatchBook /> Sales
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Main Section */}
        <div className="w-full lg:w-[85%] flex flex-col overflow-hidden h-full border border-[#d8c9ae]">
          {isMenuOpen && (
            <div
              className="block lg:hidden w-full h-full fixed backdrop-blur-[0.2rem] z-30"
              onClick={() => setIsMenuOpen(false)}
            ></div>
          )}
          <AdminHeader className="h-[5vh]" />
          <div
            className="h-[95vh] overflow-hidden"
            onClick={() => setCloseProfile(false)}
          >
            {children}
          </div>
          <MobileFooter />
        </div>
      </div>
    </div>
  );
};